const SeedRandom = require('./seedrandom');

let rng;

export default {

    formatSatoshis: function(n, decimals) {
        // return this.formatDecimals(n/100, decimals);
        return this.formatDecimals(n, decimals);
    },

    formatDecimals: function(n, decimals) {
        n = Number(n);
        if (typeof decimals === 'undefined') {
            if (n % 1 === 0)
                decimals = 0;
            else
                decimals = 2;
        }
        return n.toFixed(decimals).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    payout: function(betSize, ms) {
        return betSize * Math.pow(Math.E, (0.00006*ms));
    },

    payoutTime: function (betSize, payout) {
        return Math.log(payout/betSize)/0.00006;
    },

    seed: function (newSeed) {
        rng = SeedRandom(newSeed);
    },

    parseBet: function ($trans, betString, currency, min_bet, max_bet) {
        betString = String(betString);

        // if (!/^\d+k*$/.test(betString))
        //     return new Error('Bet may only contain digits, and k (to mean 1000)');

        // let bet = parseInt(betString.replace(/k/g, '000'));
        let bet = parseInt(betString);

        if (bet < min_bet)
            return new Error($trans(`alert.The bet should be at least`, {min_bet: this.formatSatoshis(min_bet), currency: currency}));

        if (bet > max_bet)
            return new Error($trans(`alert.The bet must be less no more than`, {max_bet: this.formatSatoshis(max_bet), currency: currency}));

        // if (_.isNaN(bet) || Math.floor(betString) !== bet)
        //     return new Error('The bet should be an integer greater than or equal to one');

        if (_.isNaN(bet) || parseFloat(betString) !== bet)
            return new Error($trans(`alert.The bet should be an integer`));

        return bet;
    },

    parseAutoCash: function ($trans, autoCashString) {
        let co = autoCashString;

        if (!/^\d+(\.\d{1,2})?$/.test(co))
            return new Error($trans('alert.Invalid auto cash out'));

        co = parseFloat(co);
        console.assert(!_.isNaN(co));

        if(co < 1)
            return new Error($trans('alert.The auto cash out amount should be bigger than 1'));

        return co;
    },

    winProb: function (amount, cashOut) {

        // The cash out factor that we need to get the cashOut with our wager.
        let factor = Math.ceil(100 * cashOut / amount);

        /* The probability that the second phase of the RNG chooses a lower
         crash point. This is derived in the following way:

         Let r be a random variable uniformly distributed on [0,1) and let
         p be 1/(1-r). Then we need to calculate the probability of
         floor(100 * (p - (p - 1)*0.01)) < factor

         Using the fact that factor is integral and solving for r yields
         r < 1 - 99 / (f-1)

         Because r is uniformly distributed the probability is identical
         to the right hand side.

         Combining with the first phase of the RNG we get the probability
         of losing
         1/101 + 100/101 * (1 - 99 / (factor-1))
         and the win probability
         1 - 1/101 - 100/101 * (1 - 99 / (factor-1)).
         = 100/101 - 100/101 * (1 - 99 / (factor-1))
         = 100/101 * (1 - (1 - 99 / (factor-1))
         = 100/101 * (99 / (factor-1))
         = 100/101 * (99 / (factor-1))
         = 9900 / (101*(factor-1))
         */
        return 9900 / (101*(factor-1));
    },

    profit: function (amount, cashOut) {

        // The factor that we need to get the cash out with our wager.
        let factor = Math.ceil(100 * cashOut / amount);

        // We calculate the profit with the factor instead of using the
        // difference between cash out and wager amount.
        return amount * (factor-100) / 100;
    },

    houseExpectedReturn: function (amount, cashOut) {

        let p1,p2,p3;
        let v1,v2,v3;

        // Instant crash.
        p1 = 1/101;
        v1 = amount;

        // Player win.
        p2 = this.winProb(amount,cashOut);
        v2 = - 0.01 * amount - this.profit(amount,cashOut);

        // Player loss.
        p3 = 1 - p1 - p2;
        v3 = 0.99 * amount;

        // Expected value.
        return p1 * v1 + p2 * v2 + p3 * v3;
    },

    capitaliseFirstLetter: function (string)
    {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },

    isInteger: function (nVal) {
        return typeof nVal === "number" && isFinite(nVal) && nVal > -9007199254740992 && nVal < 9007199254740992 && Math.floor(nVal) === nVal;
    },

    isNumber: function (nVal) {
        return typeof nVal === "number" && isFinite(nVal) && nVal > -9007199254740992 && nVal < 9007199254740992;
    },

    //Returns plural or singular, for a given amount of bits.
    grammarBits: function (bits) {
        return bits <= 100 ? 'bit' : 'bits';
    },

    //Calculate the payout based on the time
    growthFunc: function(ms) {
        console.assert(typeof ms == 'number' && ms >= 0);
        let r = 0.00006;
        return Math.floor(100 * Math.pow(Math.E, r * ms)) / 100;
    },

    //A better name
    calcGamePayout: function(ms) {
        let gamePayout = this.growthFunc(ms);
        // console.assert(isFinite(gamePayout));
        return gamePayout;
    },

    //Returns the current payout and stops when lag, use this time to calc game payout with lag
    getElapsedTimeWithLag: function(state) {
        if (state.game_state == 'IN_PROGRESS') {
            let elapsed;
            if (state.lag)
                elapsed = state.last_game_tick - state.start_time + AppConstants.Engine.STOP_PREDICTING_LAPSE; //+ STOP_PREDICTING_LAPSE because it looks better
            else
                elapsed = this.getElapsedTime(state.start_time);

            return elapsed;
        } else {
            return 0;
        }
    },

    //Just calculates the elapsed time
    getElapsedTime: function(start_time) {
        return Date.now() - start_time;
    },

    isMobileOrSmall: function() {
        return window.getComputedStyle(document.getElementById('handheld-detection'), null).display == 'none';
    },

};
